import styled from 'styled-components';
import { up } from '../../../utils/styles/breakpoints';
import { X_CARDS_MARGIN } from '../ResizableGrid/constants';

export const MasonryGridContainer = styled.div.withConfig({
    displayName: 'MasonryGridContainer',
})`
    width: 100%;
    column-gap: ${X_CARDS_MARGIN}px;
    column-count: 2;

    ${up('sm')} {
        column-count: 3;
    }

    ${up('lg')} {
        column-count: 4;
    }
`;

export const MasonryGridItemBox = styled.div.withConfig({
    displayName: 'MasonryGridItemBox',
})`
    /* блочный, а не inline-block: между инлайновыми боксами балансировщик колонок
       не находит точку разрыва и складывает карточки в одну колонку */
    display: block;
    width: 100%;
    margin-bottom: ${X_CARDS_MARGIN}px;
    break-inside: avoid;
    -webkit-column-break-inside: avoid;
`;
